/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdminPcc } from './AdminPcc';
import {
    AdminPccFromJSON,
    AdminPccFromJSONTyped,
    AdminPccToJSON,
} from './AdminPcc';
import type { Status } from './Status';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status';
import type { StatusCodes } from './StatusCodes';
import {
    StatusCodesFromJSON,
    StatusCodesFromJSONTyped,
    StatusCodesToJSON,
} from './StatusCodes';

/**
 * 
 * @export
 * @interface AdminPccResponse
 */
export interface AdminPccResponse extends Status {
    /**
     * 
     * @type {AdminPcc}
     * @memberof AdminPccResponse
     */
    adminPcc?: AdminPcc;
}

/**
 * Check if a given object implements the AdminPccResponse interface.
 */
export function instanceOfAdminPccResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdminPccResponseFromJSON(json: any): AdminPccResponse {
    return AdminPccResponseFromJSONTyped(json, false);
}

export function AdminPccResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPccResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...StatusFromJSONTyped(json, ignoreDiscriminator),
        'adminPcc': !exists(json, 'adminPcc') ? undefined : AdminPccFromJSON(json['adminPcc']),
    };
}

export function AdminPccResponseToJSON(value?: AdminPccResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...StatusToJSON(value),
        'adminPcc': AdminPccToJSON(value.adminPcc),
    };
}

